"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocationAwarePurchaseMotionData = exports.getPurchaseMotionData = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _purchaseMotionApi = require("self-service-api/core/api/purchaseMotionApi");

var _validators = require("self-service-api/core/validators");

var _availableTrialsAdapter = _interopRequireDefault(require("self-service-api/adapters/availableTrialsAdapter"));

var _adaptPurchaseMotionResponse = function _adaptPurchaseMotionResponse(purchaseMotionMetaData) {
  var availableTrials = purchaseMotionMetaData.availableTrials,
      customerCurrencyCode = purchaseMotionMetaData.customerCurrencyCode,
      productBasedOffers = purchaseMotionMetaData.productBasedOffers,
      parcels = purchaseMotionMetaData.parcels,
      subscriptionTerms = purchaseMotionMetaData.subscriptionTerms,
      merchandiseIdsTreatedAsOwned = purchaseMotionMetaData.merchandiseIdsTreatedAsOwned;
  return {
    availableTrials: (0, _availableTrialsAdapter.default)(availableTrials),
    customerCurrencyCode: customerCurrencyCode,
    productBasedOffers: productBasedOffers,
    parcels: parcels,
    subscriptionTerms: subscriptionTerms,
    merchandiseIdsTreatedAsOwned: merchandiseIdsTreatedAsOwned
  };
};

var getPurchaseMotionData = function getPurchaseMotionData() {
  var merchandiseIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  merchandiseIds.forEach(_validators.validateMerchandiseId);
  return (0, _purchaseMotionApi.fetchPurchaseMotionData)(merchandiseIds).then(function (purchaseMotionData) {
    return (0, _extends2.default)({}, _adaptPurchaseMotionResponse(purchaseMotionData), {
      purchaseMotions: purchaseMotionData.purchaseMotions
    });
  });
};

exports.getPurchaseMotionData = getPurchaseMotionData;

var getLocationAwarePurchaseMotionData = function getLocationAwarePurchaseMotionData(_ref) {
  var _ref$merchandiseIds = _ref.merchandiseIds,
      merchandiseIds = _ref$merchandiseIds === void 0 ? [] : _ref$merchandiseIds,
      locations = _ref.locations,
      apiGetter = _ref.apiGetter,
      _ref$fetchMetaData = _ref.fetchMetaData,
      fetchMetaData = _ref$fetchMetaData === void 0 ? true : _ref$fetchMetaData;

  if (!locations || locations.length === 0) {
    throw new Error('Need to specify location');
  }

  merchandiseIds.forEach(_validators.validateMerchandiseId);
  return (0, _purchaseMotionApi.fetchLocationAwarePurchaseMotionData)({
    merchandiseIds: merchandiseIds,
    locations: locations,
    apiGetter: apiGetter,
    fetchMetaData: fetchMetaData
  }).then(function (response) {
    return (0, _extends2.default)({}, response, fetchMetaData && {
      metadata: _adaptPurchaseMotionResponse(response.metadata)
    });
  });
};

exports.getLocationAwarePurchaseMotionData = getLocationAwarePurchaseMotionData;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/api/getPurchaseMotionData.js
// module id = 497
// module chunks = 5 6